module.exports = {"top3":["High out-of-pocket medical spending","Home health patients with a hospital admission","Medicare spending per beneficiary"],"bottom3":["Adults without all recommended cancer screenings","Employee insurance costs as a share of median income","Alcohol deaths"],"most_improved":["Uninsured adults","Diabetic adults without an annual hemoglobin A1c test","Home health patients without improved mobility"],"most_declined":["Alcohol deaths","Children who are overweight or obese","Preventable hospitalizations ages 18-64"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/NM.json
// module id = 272
// module chunks = 143196823979170 184088790168614